import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import Style from "./ReleveHeader.scss";
import Icon from "@mdi/react";
import { mdiArrowDownCircleOutline } from "@mdi/js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import fict from "./fictif";

const ReleveHeader = (props) => {
   const [isLoading, setIsLoading] = useState(false);
   const [asData, setAsData] = useState(true);
   const [parcelle, setParcelle] = useState();
   const [dnupro, setDnupro] = useState();
   //const [url, setUrl]= useState()
   const [ddnupro, setDdnupro] = useState();

   useEffect(() => {
      props.parcelles ? setParcelle(props.parcelles[0]) : null;
   }, [props.parcelles]);
   /*
    useEffect(()=>{
        fetchData();
    }, [url])

     */

   const handleClick = (e) => {
      let year = "2017";
      let url = "";

      switch (e) {
         case "standard":
            url = "standard";
            break;
         case "tiers":
            url = "tiers";
            break;
         case "parcelle":
            url = "parcelle";
            break;
         default:
            break;
      }
      fetchData(url);
   };

   const fetchData = (url) => {
      if (url) {
         setIsLoading(true);
         const params = {
            id_par: parcelle.substring(0, 2) + "0" + parcelle.substring(2),
            //'ddnupro': ddnupro
            releve_type: url,
         };

         axios
            .post("/Api/geodata/releve_prop/parcelle", params)
            .then((result) => {
               if (result.data) {
                  //let page = parser.parseFromString(result.data, "text/html");
                  let openPAge = window.open("", "Relevé de propriété");
                  openPAge.document.write(result.data);
                  /*console.log(page)
                        doc.html(page.body, {callback: function(doc){
                                //doc.save('dataurlnewwindow.pdf');
                                doc.save('dataurlnewwindow.pdf');
                            }});*/
               } else {
                  toast.error("Désolé, votre requête ne produit aucun résultat !");
               }
               setIsLoading(false);
            })
            .catch((err) => {
               setIsLoading(false);
               toast.error("Désolé, votre requête ne produit aucun résultat !");
            });
      }
   };

   return (
      <div id={"releve-header"}>
         <div className={"card ueThemeBackground border-0"}>
            <div className="releve-section card-body px-0">
               {props.parcelles ? (
                  <div className={"d-flex flex-column justify-content-center align-content-center"}>
                     <div className="text-center my-3">Séléctionnez la référence de votre parcelle</div>
                     <div className={"d-flex w-100 justify-content-center "}>
                        <select
                           id="ue-rev-parcelles-select"
                           className="form-control custom-select"
                           style={{ height: "unset" }}
                           onChange={(e) => setParcelle(e.target.value)}
                        >
                           {props.parcelles.map((item, index) => {
                              return (
                                 <option key={index} value={item} className={"px-2"}>
                                    {item}
                                 </option>
                              );
                           })}
                        </select>
                     </div>

                     <div className="text-center my-3 mt-5">Choisissez votre relevé de propriétaire</div>

                     <div className="form-group row">
                        <div className="col-12">
                           {isLoading ? (
                              <div className="text-center my-2">
                                 <Spinner animation="border" size={"sm"} />
                              </div>
                           ) : null}
                        </div>
                        <div className="col-12">
                           <div
                              className={"ue-releve-header-item"}
                              onClick={(e) => {
                                 handleClick("standard");
                              }}
                           >
                              <Icon path={mdiArrowDownCircleOutline} size={0.8} color={"var(--theme-primary)"} />
                              <div className={"ml-2"}> Relevé de propriété standard</div>
                           </div>
                        </div>
                        <div className="col-12">
                           <div
                              className={"ue-releve-header-item"}
                              onClick={(e) => {
                                 handleClick("tiers");
                              }}
                           >
                              <Icon path={mdiArrowDownCircleOutline} size={0.8} color={"var(--theme-primary)"} />
                              <div className={"ml-2"}> Relevé de propriété tiers</div>
                           </div>
                        </div>
                        <div className="col-12">
                           <div
                              className={"ue-releve-header-item"}
                              onClick={(e) => {
                                 handleClick("parcelle");
                              }}
                           >
                              <Icon path={mdiArrowDownCircleOutline} size={0.8} color={"var(--theme-primary)"} />
                              <div className={"ml-2"}>Relevé de propriété à la parcelle</div>
                           </div>
                        </div>
                     </div>
                  </div>
               ) : (
                  <div className="row">
                     <div className="col">Merci de séléctionner un parcelle pour afficher ses données</div>
                  </div>
               )}
            </div>
         </div>
      </div>
   );
};

export default ReleveHeader;
